import { render, staticRenderFns } from "./TenderMy.vue?vue&type=template&id=51e2aeca&"
import script from "./TenderMy.vue?vue&type=script&lang=js&"
export * from "./TenderMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports